import { useTranslate } from "@similarweb/i18n-provider";
import { AlertBanner, Button } from "@similarweb/ui-components";

import type { GaErrorKind } from "app/modules/ga-connect/classifyGaError";

interface IGaErrorBannerProps {
    errorKind: GaErrorKind;
    onReload?: () => void;
}

const errorKindConfig: Record<
    GaErrorKind,
    {
        textKey: string;
        variant: "error" | "info";
        showReload: boolean;
    }
> = {
    "access-denied": {
        textKey: "activation.ga.error.access-denied",
        variant: "error",
        showReload: false,
    },
    "dependency-failed": {
        textKey: "activation.ga.error.dependency-failed",
        variant: "info",
        showReload: false,
    },
    "rate-limited": {
        textKey: "activation.ga.error.rate-limited",
        variant: "info",
        showReload: true,
    },
    "quota-exhausted": {
        textKey: "activation.ga.error.quota-exhausted",
        variant: "info",
        showReload: false,
    },
    unknown: {
        textKey: "pro.ga-connect.banner.data-load-error.title",
        variant: "error",
        showReload: false,
    },
};

export const GaErrorBanner = ({ errorKind, onReload }: IGaErrorBannerProps) => {
    const { translate } = useTranslate();
    const config = errorKindConfig[errorKind];

    return (
        <AlertBanner
            variant={config.variant}
            shadowed
        >
            <AlertBanner.Image />
            <AlertBanner.Description>{translate(config.textKey)}</AlertBanner.Description>
            {config.showReload && onReload ? (
                <Button
                    type="flat"
                    onClick={onReload}
                >
                    {translate("activation.ga.error.reload-button")}
                </Button>
            ) : null}
        </AlertBanner>
    );
};
